import React from "react"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import { Link } from 'gatsby'

export default function PostListItemFullWidth({ post, location }) {
  return (
    <>
      { 
        post ? (
          <Link
            to={`/posts/` + post.postId}
            state={{
              from: location?.pathname
            }}
            className="thumbnail-wrapper-link"
          >
            <figure className="pickup-article-pc">
              <GatsbyImage image={getImage(post.thumbnailLandscape.src)} alt={post.title} />
            </figure>
            <figure className="pickup-article-sp">
              <GatsbyImage image={getImage(post.thumbnailSquare.src)} alt={post.title} />
            </figure>
            <div className="description">
              <span className="date">{post.postedAt.substr(0, 10).replace(/-/g, '/')}</span>
              <p className="title">{post.title}</p>
            </div>
          </Link>
        ) : ''
      }
    </>
  )
}
